module.exports = __webpack_public_path__ + "img/Dolan.9aa9f679.jpg";